import { Lead } from "../Leads/Lead";
import { CreditCard } from "./CreditCard";
import { CustomerLocation } from "./CustomerLocation";

export class Customer {
  readonly id?: number;
  first_name: string = "";
  last_name: string = "";
  prime_member: boolean = false;
  silver: boolean = false;
  location?: CustomerLocation;
  locations?: CustomerLocation[] | [];
  card?: CreditCard;
  cards?: CreditCard[] | [];
  leads?: Lead[];
  allow_sms?: boolean = false;
  allow_email?: boolean = false;
}
